import React from 'react';
import { BoxTitle } from './style';

interface Props {
    children: React.ReactNode;
}

const Title: React.FC<Props> = ({ children }) => <BoxTitle>{children}</BoxTitle>;

export default Title;
